// utils/stream.js
import { fetchEventSource } from '@microsoft/fetch-event-source' // 引入fetchEventSource库用于处理SSE（Server-Sent Events）
import { getLocalStorage, STORE_KEYS } from '@/tool/localStore';
import { token } from '@/constants/index'


import Taro from '@tarojs/taro'; // 引入Taro框架
import cog from './config'
class StreamRequest {
  config = { // 默认配置对象 
    // baseURL: cog.domain + '/v1', // API基础路径
    baseURL: 'http://dify.luyuaqua.com/v1', // API基础路径
    headers: { // 默认请求头
      'Content-Type': 'application/json', // 请求数据格式
      'Authorization': 'Bearer app-4YOR3buf6wC2AyNxTCLWK76n' // 默认的API密钥
      // 'Authorization': getLocalStorage(STORE_KEYS.token) // 默认的API密钥
    },
    timeout: 10000, // 请求超时时间（毫秒）
    retry: 3 // 重试次数（目前未使用）
  }
  // 10.31.1.105:8686/v1/chat-messages
  constructor(options = {}) { // 构造函数，合并用户配置
    this.config = { ...this.config, ...options } // 合并默认配置和用户传入的配置
    this.controller = null // 用于取消请求的AbortController实例
    this.socketTask = null // 保留的socket任务变量（目前未使用）

    this.interceptors = { // 拦截器对象
      request: null, // 请求拦截器
      response: null // 响应拦截器
    }
  }






  useRequestInterceptor(callback) { // 注册请求拦截器
    this.interceptors.request = callback // 存储用户提供的请求拦截函数
  }

  useResponseInterceptor(callback) { // 注册响应拦截器
    this.interceptors.response = callback // 存储用户提供的响应拦截函数
  }

  async request(options) { // 发送请求方法
    const mergedOptions = this._mergeConfig(options) // 合并配置

    if (this.interceptors.request) { // 执行请求拦截器
      await this.interceptors.request(mergedOptions)
    }

    return this._platformRequest(mergedOptions) // 执行平台适配的请求逻辑
  }

  _mergeConfig(options) { // 配置合并工具方法
    return {
      ...this.config, // 合并基础配置
      ...options, // 合并用户传入的请求配置
      headers: { ...this.config.headers, ...options.headers }, // 合并请求头（确保用户头覆盖默认）
    }
  }

  async _platformRequest(options) { // 平台适配的请求方法（当前仅支持fetchEventSource）
    return this._fetchEventSourceRequest(options) // 使用fetchEventSource处理SSE请求
  }

  // 新增 abort 方法
  abort() {
    if (this.controller) {
      console.log('进来');
      this.controller.abort(); // 取消请求
      this.controller = null; // 清理控制器
    }
  }

  async _fetchEventSourceRequest(options) { // 具体的SSE请求实现
    console.log('options', options);
    this.controller = new AbortController(); // 初始化控制器
    const { signal } = this.controller;
    try {
      await fetchEventSource(`${this.config.baseURL}${options.url}`, { // 发送SSE请求

        method: options.method || 'POST', // 请求方法（默认POST）
        headers: options.headers, // 请求头
        body: JSON.stringify(options.data), // 请求体（JSON格式）
        signal: signal || options.signal, // 取消信号
        onopen: async (response) => { // 连接建立时的回调
          if (this.interceptors.response) { // 执行响应拦截器预处理
            await this.interceptors.response(response)
          }
          if (response.status >= 400) { // 处理错误状态码
            const token = getLocalStorage(STORE_KEYS.token);
            // console.log('流式数据请求打印token', token);
            throw new Error(`请求失败，状态码：${response.status}`)
          }
        },
        onmessage: (msg) => { // 接收消息事件
          let data = msg.data // 获取原始消息数据
          if (this.interceptors.response) { // 执行响应拦截器处理
            data = this.interceptors.response(data)
          }
          if (options.onMessage) options.onMessage(data) // 触发用户的消息回调
        },
        onerror: (err) => { // 错误处理
          this._handleError(err, options) // 统一错误处理
          if (options.onError) options.onError(err) // 触发用户错误回调
          throw err // 抛出错误保持链式处理
        },
        onclose: () => { // 连接关闭时的回调
          if (options.onClose) options.onClose() // 触发用户关闭回调
        }
      })
    } finally {
      this.controller = null; // 请求结束后清理控制器
    }


  }

  _handleError(err, options) { // 统一错误处理方法
    const errorHandler = options.onError || this.config.onError // 获取错误处理函数
    if (errorHandler) { // 如果有自定义处理
      errorHandler(err)
    } else { // 默认使用Taro的提示
      Taro.showToast({
        title: err.message || '请求失败',
        icon: 'none',
        duration: 2000
      })
    }
  }
}

export const createStreamRequest = (options) => { // 工厂函数创建实例
  const instance = new StreamRequest(options) // 创建实例

  instance.useRequestInterceptor(async (config) => { // 注册默认请求拦截器 

    try {
      const token = config.data?.tokenKey || config.tokenKey;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.log('获取token失败', error);
    }

    return {
      ...config,
      method: config.method || 'POST' // 设置默认请求方法为POST
    }
  })

  instance.useResponseInterceptor((data) => { // 注册默认响应拦截器
    try {
      return JSON.parse(data) // 尝试将响应数据解析为JSON
    } catch (e) {
      return data // 解析失败返回原始数据
    }
  })

  return instance // 返回配置好的实例
}

export default createStreamRequest() // 默认导出已配置的实例